export const URL_API = process.env.REACT_APP_API_URL;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export const timerStatuses = {
  RUNNING: 'RUNNING',
  SUBMITTED: 'SUBMITTED',
  STOPPED: 'STOPPED',
  INITIATED: 'INITIATED'
};
export const SLO_BREACHING_TIME = 5 * 60; // 5 minutes
export const SWARM_MODE_DISABLED_COMPANY_IDS = [
  644446 // REDD
];
export const DEFAULT_TIME_ZONE = 'America/New_York';
export const SWARM_STATES = {
  RESOLVED: 'resolved',
  INITIATED: 'initiated',
  PENDING: 'pending',
  CANCELLED: 'cancelled'
};
export const THREAD_STATES = {
  DONE: 'done',
  ACTIVE: 'active',
  LIVE: 'live'
};
export const THREAD_STATE_FILTERS = {
  ACTIVE: [THREAD_STATES.ACTIVE, THREAD_STATES.LIVE],
  DONE: [THREAD_STATES.DONE],
  ALL: [THREAD_STATES.ACTIVE, THREAD_STATES.LIVE, THREAD_STATES.DONE]
};

export const INTEGRATION_COMMAND = {
  IT_GLUE: 'ITGLUE',
  AUTOMATE: 'AUTOMATE',
  COPILOT: 'COPILOT',
  WORKFLOW: 'WORKFLOW',
  PSA: 'PSA',
  TIMEZEST: 'TIMEZEST'
};

export const PSA_TYPES = {
  AUTO_TASK: 'datto_autotask',
  KASEYA_BMS: 'kaseya_bms',
  CONNECTWISE: 'connectwise',
  HALO: 'halo_psa'
};

export const CONVERSATION_SOURCES = {
  INBOX: 'inbox',
  PSA: 'psa',
  PROVIDER: 'provider',
  SLACK_CLIENT: 'slack_client',
  SLACK_MSP: 'slack_msp',
  MS_TEAMS_MSP: 'ms_teams_msp',
  MS_TEAMS_CLIENT_PERSONAL: 'ms_teams_client_personal',
  MS_TEAMS_CLIENT_CHANNEL: 'ms_teams_client_channel',
  MESSENGER: 'MESSENGER',
  MESSENGER_AGENT: 'messenger_agent',
  MESSENGER_WIDGET: 'messenger_widget',
  MESSENGER_TEAMS: 'messenger_teams',
  MESSENGER_MOBILE: 'messenger_mobile',
  ACTION_PLATFORM: 'action_platform',
  INBOX_PODS: 'inbox_pods'
};

export const THREAD_LINK_TYPES = {
  MERGE: 'merge',
  BUNDLE: 'bundle'
};

// SSR - Sentry Session Replay
export const SSR_ENABLED_COMPANY_IDS = [
  602781, // Homefield IT
  322163 // Thread Production Slack
];

export const THREAD_SORT_OPTIONS = [
  {
    label: 'Newest created',
    id: 'newestCreated',
    value: {
      sortByCreatedAt: 'DESC'
    }
  },
  {
    label: 'Oldest created',
    id: 'oldestCreated',
    value: {
      sortByCreatedAt: 'ASC'
    }
  },
  {
    label: 'Recently updated',
    id: 'recentlyUpdated',
    value: {
      sortByUpdatedAt: 'DESC'
    }
  },
  {
    label: 'Least updated',
    id: 'leastUpdated',
    value: {
      sortByUpdatedAt: 'ASC'
    }
  }
];

export const EXTERNAL_SESSION_TYPES = {
  CONNECTWISE: 'cw-pods',
  AUTOTASK: 'at-insight'
};
